import { API_BASE_URL } from '../../config';
import {
  ABTesting,
  getABTestingObject
} from '../../frameworks_drivers/redux/reducers/abTest/abTesting';
import { MiscStoreData } from '../../frameworks_drivers/redux/reducers/miscellaneous/miscSlice';
import { StoreObject } from '../../frameworks_drivers/redux/reducers/onboardingInformation';
import store from '../../store';
import { RadioOptionKeys } from '../../tools/RadioOptionMapper';
import {
  ApiEndpoint,
  ApiInterface,
  BaseAxiosClient
} from '../../interface_adapters/clients/BaseAxiosClient';
import { MetaItem, PriceResponse } from '../index';
import { PricePayload } from './index';

// TODO: Remove this when the new Http service is fully integrated
/**
 * @deprecated Please use the services/Httop.ts instead.
 * PriceClient class extends AbstractApiClient and implements ApiInterface.
 * This class is responsible for making API requests related to Pricing.
 *
 * @extends {BaseAxiosClient}
 * @implements {ApiInterface}
 */
class PriceClient extends BaseAxiosClient implements ApiInterface {
  static baseURL: string = API_BASE_URL;
  apiEndpoints: ApiEndpoint = { prices: '/api/prices' };

  constructor() {
    super(PriceClient.baseURL);
  }

  public async getPrices(): Promise<PriceResponse> {
    const payload = this.buildPayloadFromStore(getABTestingObject());
    return this.post(this.apiEndpoints.prices, payload);
  }

  public async getFullPrices(): Promise<PriceResponse> {
    const payload = this.buildPayloadFromStore(getABTestingObject(), true);
    return this.post(this.apiEndpoints.prices, payload);
  }

  private buildPayloadFromStore(abTesting: ABTesting, forceFullPrice: boolean = false) {
    const { onboardingInfo, misc } = store.getState();
    return this.buildPayload(onboardingInfo, misc, abTesting, forceFullPrice);
  }

  private buildPayload(
    onboardingInfo: StoreObject,
    misc: MiscStoreData,
    abTesting: ABTesting,
    forceFullPrice: boolean
  ) {
    let payload: PricePayload = {
      numberOfApartments: onboardingInfo.numberOfApartments,
      heatingCostsInvoice: onboardingInfo.heatingCostsInvoice,
      centralHotWaterDelivery:
        onboardingInfo.centralHotWaterDelivery === RadioOptionKeys.HotWaterDeliveryCentral.Yes,
      heatingType: onboardingInfo.heatingType,
      heatingSources: onboardingInfo.heatingSources,
      email: onboardingInfo.contactDetails.email,
      meta: buildMetaArray(abTesting)
    };

    // If referral code is used, set the discount code
    if (!forceFullPrice && misc && misc.referralDiscountCode) {
      payload.discountCode = misc.referralDiscountCode!;
    }

    return payload;
  }
}

// utils.ts
function buildMetaArray(abTesting: ABTesting): MetaItem[] {
  const names: Array<keyof ABTesting> = ['pricing', 'stockShortage'];
  const metaArr: MetaItem[] = names.map((name) => ({
    type: 'ab_test',
    name: name,
    value: abTesting[name].scenario
  }));

  metaArr.map((item) => {
    if (item.name === 'pricing' && item.value === null) {
      item.value = 'default';
    }
    return item;
  });

  return [...metaArr, ...extractQueryParameters(window.location.search)];
}

// forward all client url params to BE for analytics purposes
function extractQueryParameters(search: string): MetaItem[] {
  const params = new URLSearchParams(search);
  const queryParameters: MetaItem[] = [];
  params.forEach((value, key) => {
    queryParameters.push({ type: 'query_parameter', name: key, value });
  });
  return queryParameters;
}

export { PriceClient };
